var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "NotificationsRoot",
    {
      attrs: {
        authorized: _vm.userIsAuthorized,
        authorizedRole: "registeredUser",
      },
    },
    [_c("router-view", { attrs: { loading: _vm.loading } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }